<div class="login-wrapper">
	<div class="login-content" [class.terms-pending]="!acceptedTerms">
		@if (!loggedIn()) {
			<amplify-authenticator [formFields]="formFields" [services]="services">
				<ng-template amplifySlot="unauthenticated">
					<h2 i18n="@@SignIn">Sign In</h2>
					<!-- Amplify login form -->
				</ng-template>
				<ng-template amplifySlot="sign-up-form-fields">
					<amplify-sign-up-form-fields></amplify-sign-up-form-fields>
					<label class="opt-in-label">
						<input type="checkbox" [(ngModel)]="optInProdUpdates" name="opt_in_prod_updates" />
						<span i18n="@@OptInLabel">I want to receive product information</span>
					</label>
					<label class="opt-in-label terms-label">
						<input type="checkbox" [(ngModel)]="acceptedTerms" name="accept_terms" />
						<span i18n="@@TermsLabel">I have read and accept the <a [href]="termsUrl" target="_blank" rel="noopener noreferrer">terms and conditions</a>.</span>
					</label>
				</ng-template>
			</amplify-authenticator>
		}
		@else {
			<h2 i18n="@@Welcome">Welcome!</h2>
		}
	</div>
</div>
